import React from 'react';

interface ShieldIconProps {
  size?: number;
  className?: string;
  style?: React.CSSProperties;
}

export const ShieldIcon: React.FC<ShieldIconProps> = ({
  size = 24,
  className,
  style,
}) => {
  return (
    <svg
      width={size}
      height={(size * 30) / 24} // Maintain aspect ratio
      viewBox="0 0 24 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <path
        d="M23.1462 16.148C23.1462 23.1469 18.2471 26.6463 12.424 28.676C12.1191 28.7793 11.7879 28.7743 11.4862 28.662C5.64918 26.6463 0.75 23.1469 0.75 16.148V6.34969C0.75 5.97845 0.897475 5.62242 1.15998 5.35991C1.42249 5.0974 1.77852 4.94993 2.14977 4.94993C4.9493 4.94993 8.44871 3.27021 10.8843 1.14256C11.1808 0.889204 11.5581 0.75 11.9481 0.75C12.3382 0.75 12.7154 0.889204 13.0119 1.14256C15.4615 3.2842 18.9469 4.94993 21.7465 4.94993C22.1177 4.94993 22.4738 5.0974 22.7363 5.35991C22.9988 5.62242 23.1462 5.97845 23.1462 6.34969V16.148Z"
        fill="#492B87"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.34912 14.748H6.36312"
        stroke="white"
        strokeWidth="1.67972"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.9482 14.748H11.9622"
        stroke="white"
        strokeWidth="1.67972"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.5474 14.748H17.5614"
        stroke="white"
        strokeWidth="1.67972"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ShieldIcon;
